import { combineReducers } from "redux";

import accessToken from "./auth";

export const reducers = combineReducers({ accessToken });
